import { create } from 'zustand';

const pageStore = create((set, get) => ({
  currentPage: null, // Exemple: 'home', 'about', 'details', etc.

  setCurrentPage: (pageType) => set({ currentPage: pageType }),

  registeredHandler: null,
  registerHandler: (fn) => set({ registeredHandler: fn }),

  // Appel depuis n'importe où
  triggerHandler: () => {
    const { registeredHandler } = get();
    //alert('typof' + typeof registeredHandler)
    if (typeof registeredHandler === 'function') {
      registeredHandler();
    }
  },

}));

export default pageStore;
